// BHP-1070: the onboarding decision. Backend2.0 exposes only `customerUuids` on
// the account; an empty list means the account is provisioned (BHP-1069) but has
// no customer yet → onboarding.
import type { AccountData } from './accountData';

/**
 * True when the account exists but is not yet linked to any customer, i.e. a
 * freshly provisioned sign-up that must go through onboarding before it can work
 * in a customer context.
 */
export function needsOnboarding(account: AccountData): boolean {
  return account.customerUuids.length === 0;
}
